// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Relation/Relation.css */
.relation-line-visual {
    pointer-events: none;
  }
  
  .relation-line-interactive {
    cursor: pointer;
    stroke: transparent;
    stroke-width: 10px;
  }
  
  .relation-context-menu {
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  .relation-context-menu button {
    width: 100%;
    padding: 5px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
  }
  
  .relation-context-menu button:hover {
    background-color: #f0f0f0;
  }
  /* In your Relation.css or a global CSS file */
  .relation-menu {
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  }
  
  .relation-menu button {
    display: block;
    width: 100%;
    padding: 5px;
    margin: 2px 0;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
  }
  
  .relation-menu button:hover {
    background-color: #f0f0f0;
  }

/* Highlighted relation animation */
.relation-highlighted .relation-line-visual.highlighted {
  animation: pulse-line 0.5s ease-in-out 3;
}

@keyframes pulse-line {
  0%, 100% {
    stroke-width: 4;
    opacity: 1;
  }
  50% {
    stroke-width: 6;
    opacity: 0.8;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Relation/Relation.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;EACA,8CAA8C;EAC9C;IACE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;AAEF,mCAAmC;AACnC;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* src/components/Relation/Relation.css */\n.relation-line-visual {\n    pointer-events: none;\n  }\n  \n  .relation-line-interactive {\n    cursor: pointer;\n    stroke: transparent;\n    stroke-width: 10px;\n  }\n  \n  .relation-context-menu {\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n  }\n  \n  .relation-context-menu button {\n    width: 100%;\n    padding: 5px;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n  }\n  \n  .relation-context-menu button:hover {\n    background-color: #f0f0f0;\n  }\n  /* In your Relation.css or a global CSS file */\n  .relation-menu {\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n  }\n  \n  .relation-menu button {\n    display: block;\n    width: 100%;\n    padding: 5px;\n    margin: 2px 0;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n  }\n  \n  .relation-menu button:hover {\n    background-color: #f0f0f0;\n  }\n\n/* Highlighted relation animation */\n.relation-highlighted .relation-line-visual.highlighted {\n  animation: pulse-line 0.5s ease-in-out 3;\n}\n\n@keyframes pulse-line {\n  0%, 100% {\n    stroke-width: 4;\n    opacity: 1;\n  }\n  50% {\n    stroke-width: 6;\n    opacity: 0.8;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
